import projection from '../generated/pwd202f1.json';
import { AcceptanceManifest } from '../types';

export const pwd202f1AcceptanceManifest = projection as AcceptanceManifest;
